var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_6939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 14L8.00031 11.5L4.00031 14V3C4.00031 2.86739 4.05298 2.74021 4.14675 2.64645C4.24052 2.55268 4.3677 2.5 4.50031 2.5H11.5003C11.6329 2.5 11.7601 2.55268 11.8539 2.64645C11.9476 2.74021 12.0003 2.86739 12.0003 3V14Z",
    stroke: "#454551",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_6939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkGray);
export default __webpack_public_path__ + "static/media/bookmark-gray.41661f2af6a1793bca5c80ee7d902b4e.svg";
export { ForwardRef as ReactComponent };